import Chart from 'chart.js';

/**
 * Create a custom line chart type (extended from default line chart), that draws
 *  vertical lines over the hovered points.
 */
Chart.defaults.LineWithHover = Chart.defaults.line;
Chart.controllers.LineWithHover = Chart.controllers.line.extend({
  draw: function(ease) {
    Chart.controllers.line.prototype.draw.call(this, ease);

    if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
      let activePoint = this.chart.tooltip._active[0],
        ctx = this.chart.ctx,
        x = activePoint.tooltipPosition().x,
        topY = this.chart.legend.bottom,
        bottomY = this.chart.chartArea.bottom;

      // draw line
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 2;
      ctx.strokeStyle = 'rgba(74, 194, 255, 0.31)';
      ctx.stroke();
      ctx.restore();
    }
  }
});
